module.exports = __webpack_public_path__ + "img/user-1.2d835305.svg";